import { useState } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { Chip, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { deleteMaintenanceTasks, patchMaintenanceTasksConfirm } from 'components/axios/maintenanceAxios';
import FileDownloadIcon from 'components/FileDownloadIcon';
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MaintenanceRequestLayer from 'components/layer/MaintenanceRequestLayer';

const MaintenanceTaskInfoCard = ({maintenanceTask, setIsLoading : setParentIsLoading, linkTarget=""}) => {
    const { getEnumValueByEnumNameAndCode, role } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
      openModal(modals.alertModal, {
          onClose : () => {
              console.log('');
          },
          message: alertMessage,
      });
    };

    const confirmUserModal = (id) => {
      openModal(modals.promptModal, {
        onSubmit : (value) => {
            //console.log(id);
            //console.log(value);
            let body = {
                id,
                confirmUser : value,
                //chkedAt : moment().format(),
            }
            //console.log(body);
            patchMaintenanceTasksConfirm(id, body).then((res) => {
                alertMessage = t('message.common.alert.confirm.complete');
                setAlertMessage(alertMessage);
                handleAlertClick();
                setParentIsLoading(false);
            })
        },
        onClose : () => {
            console.log('close');
        },
        message: t('message.common.alert.maintenance.confirm.handler.input'),
        originValue : ''
        //label : '비고'
      });
    }

    const handleDeleteBtnClick = (param) => {
      console.log(param)
      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          deleteMaintenanceTasks(param).then((res) => {
            document.location.href = '/maintenance-history'+window.location.search;
          }).catch((err)=>{
            console.log(err);
            if (!err.response?.data?.message) {
              alertMessage = err.message;
              setAlertMessage(alertMessage);
              handleAlertClick();
            } else if (err.response.data.message) {
              alertMessage = err.response.data.message;
              setAlertMessage(alertMessage);
              handleAlertClick();
            }
          });
        },
        onClose : () => {
          console.log('close');
        },
        message: t('message.common.alert.maintenance.delete.question'),
      });
    }

    //if (isLoading && maintenanceTask) {
    if (maintenanceTask) {
      return (
        <>
            <MainCard className="center_table" content={false}>
              <div className='history_tit' style={{display: "flex", alignItems: "center", backgroundColor:"#353535"}}>
                <div style={{marginBottom:"7px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.maintenance')} color="success"/>
                </div>
              </div>

              <TableContainer>
                <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                  <TableBody>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.equipment.component')}</TableCell>
                      <TableCell align="center">{maintenanceTask.equipmentCtgr && maintenanceTask.equipmentCtgr.name} - {maintenanceTask.position}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.provider.type')}</TableCell>
                      <TableCell align="center">{maintenanceTask.mntSpType && getEnumValueByEnumNameAndCode("MaintenanceProviderType", maintenanceTask.mntSpType) && getEnumValueByEnumNameAndCode("MaintenanceProviderType", maintenanceTask.mntSpType)[0].title}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.analysis.type')}</TableCell>
                      <TableCell align="center">{maintenanceTask.recordType && getEnumValueByEnumNameAndCode("MaintenanceRecordType", maintenanceTask.recordType) && getEnumValueByEnumNameAndCode("MaintenanceRecordType", maintenanceTask.recordType)[0].title}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.date')}</TableCell>
                      <TableCell align="center">{maintenanceTask.troubledAt && dayjs(maintenanceTask.troubledAt).format("YYYY-MM-DD")}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.time')}</TableCell>
                      <TableCell align="center">{maintenanceTask.troubledAt && dayjs(maintenanceTask.troubledAt).format("HH:mm:ss")}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.cause')}</TableCell>
                      <TableCell align="center">{maintenanceTask.troubleReason}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.work.start.date')}</TableCell>
                      <TableCell align="center">{maintenanceTask.workingBgnAt && dayjs(maintenanceTask.workingBgnAt).format("YYYY-MM-DD")}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.work.start.time')}</TableCell>
                      <TableCell align="center">{maintenanceTask.workingBgnAt && dayjs(maintenanceTask.workingBgnAt).format("HH:mm:ss")}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.used.equipment')}</TableCell>
                      <TableCell align="center">{maintenanceTask.usedMethod}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.work.end.date')}</TableCell>
                      <TableCell align="center">{maintenanceTask.workingEndAt && dayjs(maintenanceTask.workingEndAt).format("YYYY-MM-DD")}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.work.end.time')}</TableCell>
                      <TableCell align="center">{maintenanceTask.workingEndAt && dayjs(maintenanceTask.workingEndAt).format("HH:mm:ss")}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.actionType')}</TableCell>
                      <TableCell align="center">{maintenanceTask.type && getEnumValueByEnumNameAndCode("MaintenanceType", maintenanceTask.type) && getEnumValueByEnumNameAndCode("MaintenanceType", maintenanceTask.type)[0].title}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.worker')}</TableCell>
                      <TableCell align="center">{maintenanceTask.worker}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.work.status')}</TableCell>
                      <TableCell align="center">
                        <div className={(maintenanceTask.status === 'O1_R' ? "condition1":(maintenanceTask.status === 'O2_P' ? "condition3":
                            (maintenanceTask.status === 'O3_C' ? "condition6":"condition5")))}>
                            {(maintenanceTask.status && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status) && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status)[0].title)}
                        </div>
                            {/* {(maintenanceTask.status && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status) && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status)[0].title)} */}
                        {maintenanceTask.status && maintenanceTask.status === 'O4_V' && (""+maintenanceTask.confirmUser)}
                      </TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.expense')}</TableCell>
                      <TableCell align="center">&#8361; {maintenanceTask.cost && maintenanceTask.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.work.detail')}</TableCell>
                      <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                        {maintenanceTask.remark}
                      </TableCell>
                    </TableRow>
                    {maintenanceTask.equipmentParts &&
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.input.material')}</TableCell>
                      <TableCell className="pl" colSpan={5} style={{textAlign:"left",padding:"0"}}>
                        <Table sx={{ minWidth: 800 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.quantity')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {maintenanceTask.equipmentParts.map(function(item, i) {
                              return (
                            <TableRow key={i}>
                              <TableCell align="center">{item.masterEquipmentPart.name}</TableCell>
                              <TableCell align="center">{item.cnt}</TableCell>
                            </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.status.report.date')}</TableCell>
                      <TableCell align="center">{maintenanceTask.statusReport && maintenanceTask.statusReport.reportYmd}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.status.reporter')}</TableCell>
                      <TableCell align="center">{maintenanceTask.statusReport && maintenanceTask.statusReport.reportUser}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.status.report.file')}</TableCell>
                      <TableCell align="center">
                        {maintenanceTask.statusReport && maintenanceTask.statusReport.reportFiles && maintenanceTask.statusReport.reportFiles.map(function(file, idx) {
                            return (
                              <div key={idx}><FileDownloadIcon file={file} viewFileName={true}/>{(maintenanceTask.statusReport.reportFiles-1)>idx && <br/>}</div>
                            )
                          })
                        }
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </MainCard>

            { role !== ROLE.MO.code &&
            <div className="btn_right">
              {/* {maintenanceTask === null || maintenanceTask.status === 'O3_C' || maintenanceTask.status === 'O4_V' &&
              <MaintenanceRequestLayer alertId={maintenanceTask.equipmentAlert.id} setIsLoading={setParentIsLoading} type="modify" />
              }
              {maintenanceTask && maintenanceTask.status !== 'O3_C' && maintenanceTask.status !== 'O4_V' && */}
              <MaintenanceRequestLayer alertId={maintenanceTask.equipmentAlert.id} setIsLoading={setParentIsLoading} type="modify" />
              {/* } */}
              {(maintenanceTask && maintenanceTask.status === 'O3_C' && (role === ROLE.SA.code || role === ROLE.WA.code)) && 
              <>&nbsp;&nbsp;<Button variant="contained" /*style={{padding:"0 9px", color:"#fff"}}*/
                onClick={()=>{confirmUserModal(maintenanceTask.id)}}>{t('message.common.btn.maintenance.confirm')}</Button></>
              }
              {(linkTarget === 'maintenance-history' && maintenanceTask && maintenanceTask.status !== 'O4_V' && (role === ROLE.SA.code || role === ROLE.WA.code)) &&
              <>&nbsp;&nbsp;<Button variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(maintenanceTask.id)}}>
                {t('message.common.btn.delete')}
              </Button></>
              }
            </div>
            }
        </>
      )
    }
}

export default MaintenanceTaskInfoCard;